import { useState, useRef } from 'react';
import { CustomModal } from '../DeleteModal';
import clsx from "clsx";
import { Image, Dropdown, Menu } from "antd";
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//     'pdfjs-dist/build/pdf.worker.min.js',
//     import.meta.url,
// ).toString();
const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

export default function PDFViewer(props) {
    const { visible, onClose, classes, pdfName, type } = props;
    const [numPages, setNumPages] = useState();
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();

    const [pageNumber, setPageNumber] = useState(1);
    const [renderNavButtons, setRenderNavButtons] = useState(false);

    const changePage = (number) => {
        setPageNumber(prevPageNumber => prevPageNumber + number);
    }
    const previousPage = () => { changePage(-1); }
    const nextPage = () => { changePage(+1); }
    const pdfContent = useRef(null);

    return (
        <CustomModal
            visible={visible}
            title={false}
            onClose={() => {
                onClose(); setPageNumber(1);
                if (document.getElementById('iframe_video')) {
                    var iframe = document.getElementById('iframe_video'), iframeSrc = iframe.src;
                    iframe.src = iframeSrc;
                }
            }}
            customClasses={clsx(classes.customShortCutKeys, classes.pdfViewer, { [classes.customShortCutKeysVideo]: type === 'Video View' })}
            text={<div style={{ height: "100%" }}>
                <div ref={pdfContent} className={clsx(classes.customPdfViewerMain, { [classes.customVideoViewerMain]: type === 'Video View' })}>
                    <div className={classes.hamburgerMenu}>
                        <Dropdown
                            overlayClassName={clsx(classes.customShortCutKeyhamburgerMenu)}
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu)}>
                                    {/* <Menu.Item key={'short_print'}><NavLink to={'#'} onClick={() => handleImageDownload('print')}>Print</NavLink></Menu.Item> */}
                                    <Menu.Item key={'short_download'}><a rel="noreferrer" target="_blank" href={type === 'Pdf View' ? pdfName : `https://youtube.com/embed/${pdfName}`} download>Download</a></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </div>
                    {
                        type === 'Pdf View' ? <Document file={pdfName} className={classes.customPdfViewer} onLoadSuccess={({ numPages }) => {
                            setNumPages(numPages);
                            setRenderNavButtons(true);
                            setWidth(pdfContent?.current?.offsetWidth);
                            setHeight(pdfContent?.current?.offsetHeight);
                        }}>
                            {/* <Thumbnail width={100}  pageNumber={pageNumber} /> */}
                            <Page width={width} height={height} pageNumber={pageNumber} />
                        </Document> : <iframe className='video'
                            id="iframe_video"
                            title={pdfName}
                            allow="autoplay"
                            frameBorder="0"
                            allowFullScreen
                            src={`https://youtube.com/embed/${pdfName}?cc_load_policy=0&rel=0&showinfo=0`}>
                        </iframe>
                    }

                    {renderNavButtons && type === 'Pdf View' &&
                        <div className={classes.customPdfViewerbutton}>
                            <span
                                className={clsx(classes.pdfPreview, { [classes.disabled]: pageNumber <= 1 })}
                                onClick={previousPage}
                            > ‹</span>
                            <span>{`${pageNumber} of ${numPages}`}</span>
                            <span
                                className={clsx(classes.pdfNext, { [classes.disabled]: pageNumber === numPages })}
                                onClick={nextPage}
                            > ›</span>
                        </div>}
                </div>
            </ div>}
        />
    )
}

